export default "__VITE_ASSET__BLc_p3mw__"